import PropTypes from 'prop-types';

const NoMatchButtonPropTypes = {
  classes: PropTypes.object.isRequired,
};

export default NoMatchButtonPropTypes;
